import Picture from '@/components/picture'

interface Props {
  image: string
  imageAlt: string
  description: string
  index: number
}

const SoilStep = ({ image, imageAlt, description, index }: Props) => (
  <article>
    <Picture
      image={image}
      imageAlt={imageAlt}
      imageStyle="aspect-square w-72"
    />
    <p className="font-natosans-bold text-[#333333] mt-4 mb-2.5 pt-4 pb-2.5 text-4xl">
      {index}
    </p>
    <p className="text-[#646464] sm:text-lg text-sm mb-2.5">{description}</p>
  </article>
)

export default SoilStep
